import { clsx } from 'clsx';
import { useSidebar } from "../../sidebar-context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Subtitle = function Subtitle(_ref) {
  var text = _ref.text;
  var _useSidebar = useSidebar(),
    sidebarCollapsed = _useSidebar.sidebarCollapsed;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-font-label1 tw-mb-0.8 tw-mx-1.2 sm:tw-ml-2 sm:tw-mr-1.6 sm:min-w-212', 'tw-text-neutral-dark-700 dark:tw-text-neutral-light-600', sidebarCollapsed && 'hidden'),
    children: text
  });
};